<template>
	<v-row class="pb-offset ma-0">
		<v-col class="pa-0" cols="12">
			<v-card class="flex pa-0 round-card background-2">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Il mio Profilo</p>
                    <v-spacer></v-spacer>
					<signature-dialog
						ref="signatureDialog"
						:signature.sync="signature"
						model-def="profile"
						button-component="v-btn"
						:model="profile"
						:button="signatureButton"
					></signature-dialog>
                	</v-card-title>        
				<v-divider></v-divider>
				<v-container fluid>
					<v-row align="center" justify="center">
						<v-col cols="3" lg="2" class="text-center pr-3 justify-center d-flex">
							<image-input v-model="avatar" @input="uploadImage">
								<div slot="activator" class="pa-2" style="border-radius: 50% !important; border: 2px solid #ececec;">
									<v-avatar :size="120" v-ripple v-if="!profile.avatar" class="grey lighten-3 cursor-pointer">
										<v-icon :size="60">account_circle</v-icon>
									</v-avatar>
									<v-avatar v-else
                                    	:size="120" 
										v-ripple
										class="custom-avatar cursor-pointer"
										:style="{'background-image': 'url(' + profile.avatar + ')'}">
									</v-avatar>
								</div>
							</image-input>
						</v-col>
						<v-col class="xs" lg="10">
							<v-form v-model="valid" enctype="multipart/form-data" ref="fieldsgenerator">
								<v-text-field
									v-validate="'required|max:255'"
									data-vv-name="Nome e Cognome"
									:error-messages="errors.collect('Nome e Cognome')"
									v-model="name"
									required
									label="Nome e Cognome"
									type="text"
									@keyup.enter="submit"
									outlined
									dense
								></v-text-field>
								<v-text-field
									data-vv-name="Email"
									:error-messages="errors.collect('Email')"
									v-model="email"
									required
                					v-validate="emailValidation"
									label="Email"
									type="email"
									@keyup.enter="submit"
									outlined
									dense
								></v-text-field>
								<v-text-field
									v-model="primary_telephone"
									label="Telefono"
									v-validate="'max:255'"
									type="text"
									@keyup.enter="submit"
									outlined
									dense
								></v-text-field>
							</v-form>
						</v-col>
					</v-row>
					<v-row class="px-0">
						<v-col cols="12" class="px-0">			
						
							<v-row class=" px-0 pb-2 ma-0">
								<v-col class="col-12 px-6 py-0">
									<v-text-field
										label="Nuova Password"
										name="new_password"
										v-model="password"
										:append-icon="e1 ? 'visibility' : 'visibility_off'"
										@click:append="() => {e1 = !e1}"
										:type="!e1 ? 'password' : 'text'"
										ref="new_password"
										outlined
										dense
									></v-text-field>
								</v-col>
								
								<v-col class="col-12 px-6 py-0">
									<v-text-field
										label="Conferma Password"
										name="confirm_password"
										v-model="password_confirmation"
										:append-icon="e2 ? 'visibility' : 'visibility_off'"
										@click:append="() => {e2 = !e2}"
										:type="!e2 ? 'password' : 'text'"
										ref="confirm_password"
										outlined
										dense
									></v-text-field>
								</v-col>

							</v-row>

							<v-fade-transition>
								<div v-show="password.length > 0">
									<v-row class="px-12 py-1 ma-0">
										<v-icon :color="passwordLength ? 'success' : 'error'">{{ passwordLength ? 'check' : 'warning' }}</v-icon><div class="ma-auto ml-4 caption">Lunghezza minima 8 caratteri</div>
									</v-row>
									<v-row class="px-12 py-1 ma-0">
										<v-icon :color="passwordNumber ? 'success' : 'error'">{{ passwordNumber ? 'check' : 'warning' }}</v-icon><div class="ma-auto ml-4 caption">Almeno un carattere numerico</div>
									</v-row>
									<v-row class="px-12 py-1 ma-0 ma-auto">
										<v-icon :color="passwordCharacter ? 'success' : 'error'">{{ passwordCharacter ? 'check' : 'warning' }}</v-icon><div class="ma-auto ml-4 caption">Almeno un carattere maiuscolo e uno minuscolo</div>
									</v-row>
									<v-row class="px-12 py-1 ma-0 ma-auto">
										<v-icon :color="validPasswordConfirm ? 'success' : 'error'">{{ validPasswordConfirm ? 'check' : 'warning' }}</v-icon><div class="ma-auto ml-4 caption">Conferma Password</div>
									</v-row>
								</div>
							</v-fade-transition>

						</v-col>
					</v-row>
					<v-row justify="end" class="px-4">
						<v-btn class="mx-2" @click="changePassowrd" :disabled="!validPasswordRules" :loading="saving" dark color="blue">
							aggiorna password
						</v-btn>
					</v-row>

				    <p class="pl-3">Impostazioni</p>

					<v-subheader class="pl-4">Notifiche</v-subheader>
					<v-row class="px-4">
						<v-col cols="12" lg="4" md="4" sm="12" class="py-0">
							<v-switch
								inset
								class="text-center"
								label="Ricevi Notifiche"
								v-model="allow_notifications"
								:input-value="[true,false]"
								color="primary"
							></v-switch>
						</v-col>
						<v-slide-x-transition>
							<v-col lg="4" md="4" sm="12" cols="12" class="py-0" v-show="allow_notifications">
								<v-switch v-if="allow_notifications"
									inset
									class="text-center"
									label="Ricevi Notifiche Mail"
									v-model="allow_mail"
									:input-value="[true,false]"
									color="primary"
								></v-switch>
							</v-col>
						</v-slide-x-transition>
						<v-slide-x-transition>
							<v-col lg="4" md="4" sm="12" cols="12" class="py-0" v-show="allow_notifications">
								<v-switch v-if="allow_notifications"
									inset
									class="text-center"
									label="Ricevi Notifiche Push"
									v-model="allow_push"
									:input-value="[true,false]"
									color="primary"
								></v-switch>
							</v-col>
						</v-slide-x-transition>
					</v-row>

					<template v-if="$store.getters.checkModulePermissions('tickets')">
						<v-subheader class="pl-4">Offline</v-subheader>
						<v-row class="py-0 px-4" align="center">
							<v-col lg="4" md="4" sm="12" cols="12" class="py-0">
								<v-switch
									inset
									class="text-center"
									label="Attiva modalità Offline"
									v-model="offline"
									:input-value="[true,false]"
									color="primary"
								></v-switch>
							</v-col>
						</v-row>

						<v-subheader class="pl-4">Ticket</v-subheader>
						<v-row class="py-0 px-4" align="center">
							<v-col cols="12" class="py-0">
								<v-switch
									inset
									class="text-center"
									label="Attiva scheda di riepilogo in visualizzazione Ticket da mobile"
									v-model="ticket_summary"
									:input-value="[true,false]"
									color="primary"
								></v-switch>
							</v-col>
						</v-row>
					</template>
				</v-container>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="mx-2" color="primary" @click.native="submit" :loading="saving" :disabled="!valid">Salva</v-btn>
                </v-card-actions>
			</v-card>
		</v-col>

		<profile-two-factor></profile-two-factor>
		
		<v-col class="pa-0" cols="12">
			<v-card class="flex pa-0 round-card background-2">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">API</p>
                </v-card-title>        
				<v-divider></v-divider>

				<!-- <passport-clients></passport-clients> -->
				<passport-authorized-clients></passport-authorized-clients>
				<v-divider></v-divider>
				<passport-personal-access-tokens></passport-personal-access-tokens>
				
				<v-row class="px-4">
					<v-col cols="12">
						<v-alert class="background-2">
							<v-row align="center">
								<v-col class="grow">
									<v-list-item-title>Logout</v-list-item-title>
									<v-subheader class="px-0">Effettua il Logout su tutti i dispositivi da cui ti sei connesso</v-subheader>
								</v-col>
								<v-col class="shrink">
									<v-btn class="mx-0" color="red" dark @click.stop="logoutDialog = true">
										Esci da tutti i dispositivi
										<v-icon class="ml-4">mdi-exit-to-app</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-alert>
					</v-col>
				</v-row>
			</v-card>
		</v-col>

		<v-dialog v-model="logoutDialog" max-width="600" persistent>
			<v-card class="background-2 round-card">
				<v-card-title primary-title class="subtitle-1 background-2">Logout</v-card-title>
				<v-divider></v-divider>
				<v-card-text style="min-height: 100px;" class="pt-4 body-2">Vuoi davvero scollegarti da tutti i dispositivi da cui ti sei connesso? Verrai disconnesso anche da questa sessione</v-card-text>
				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="info" @click.native.stop="logoutDialog = false" >Annulla
					</v-btn>
					<v-btn text color="error" @click.native.stop="logoutAll()">Esci
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
			
	</v-row>
</template>

<script>
	import Dexie from 'dexie'
	import SignatureDialog from '@/components/common/SignatureDialog'
	import ProfileTwoFactor from '@/components/user/ProfileTwoFactor'

	export default {
		name: 'profile',
		components: {
			SignatureDialog,
			ProfileTwoFactor
		},

		props: {
		},

		data() {
			return {
				name: '',
				e1: false,
				e2: false,
				email: '',
				primary_telephone: '',
				offline: '',
				valid: false,
				avatar: null,
				password: '',
				saving: false,
				signature: '',
				allow_push: '',
				allow_mail: '',
				password_confirmation: '',
				validPassword: false,
				allow_notifications: '',	
				ticket_summary: false,
				logoutDialog: false,
				signatureButton: {params: {fab: false, tooltip: 'La tua Firma'}},

				//pasword
				passwordLength: false,
				passwordNumber: false,
				passwordCharacter: false,
				validPasswordConfirm: false,

			}
		},

		computed: {

			profile() {
				return this.$store.getters.getProfile
			},

			validPasswordRules() {
				return this.passwordLength && this.passwordNumber && this.passwordCharacter && this.validPasswordConfirm
			},

			emailValidation() {
				if(this.profile && this.profile.id) {
					return 'required|email|max:255|server:user,unique,email,' + this.profile.id
				} else {
					return 'required|email|max:255'
				}
			}
		},

		watch: {
			password: {
				handler(newVal, oldVal) {
					if(newVal.length >= 8 && newVal.length <= 255) {
						this.passwordLength = true
					} else {
						this.passwordLength = false
					}
					if(/(?=\D*\d)/.test(newVal)) {
						this.passwordNumber = true
					} else {
						this.passwordNumber = false
					}
					if(/(?=[^A-Z]*[A-Z])/.test(newVal)) {
						this.passwordCharacter = true
					} else {
						this.passwordCharacter = false
					}
					if(newVal == this.password_confirmation) {
						this.validPasswordConfirm = true
					} else {
						this.validPasswordConfirm = false
					}					
				}
			},

			password_confirmation: {
				handler(newVal, oldVal) {
					if(newVal == this.password) {
						this.validPasswordConfirm = true
					} else {
						this.validPasswordConfirm = false
					}
				}
			}			
		},

		mounted() {
			let profile_temp = this.profile
			this.name = profile_temp.name
			this.email = profile_temp.email
			this.primary_telephone = profile_temp.primary_telephone
			this.signature = profile_temp.signature
			this.allow_notifications = profile_temp.allow_notifications
			this.allow_mail = profile_temp.allow_mail
			this.allow_push = profile_temp.allow_push
			this.offline = profile_temp.offline
			this.ticket_summary = profile_temp.ticket_summary
		},

		created() {
			this.$store.commit('endProgress')
		},

		methods: {

			submit() {
				this.saving = true
				this.axios.put('profile', {
					name: this.name,
					email: this.email,
					primary_telephone: this.primary_telephone,
					allow_notifications: this.allow_notifications,
					allow_mail: this.allow_mail,
					allow_push: this.allow_push,
					offline: this.offline,
					ticket_summary: this.ticket_summary,
				}).then(this.savedProfile)
				.catch(() => {
					this.saving = false
				})						
			},

			changePassowrd() {
				this.$validator.validateAll().then(result => {
				    if (!result) {
				        return false
				    }
					this.saving = true
				    this.axios.put('profile', {
				    	password: this.password,
				    	password_confirmation: this.password_confirmation
				    }).then(this.savedProfile)
					.catch(() => {
						this.saving = false
					})

				}).catch(() => {
					this.saving = false
				})
			},

			uploadImage() {
				this.saving = true
				this.axios.put('profile', {avatar: this.avatar}).then(this.savedProfile)
			},

			savedProfile() {
				this.saving = false
				this.$store.commit('setSnackbar', {timeout: 6000, text: 'Profilo aggiornato', value: true, color: 'success'})
				this.$store.dispatch('USER_REQUEST').then(() => {
					this.saving = false
				})
				if(this.offline != this.profile.offline) {
					this.$store.dispatch('syncDB')
				} else {
					Dexie.delete('YelloDB_' + localStorage.fqdn)
				}
			},

			logoutAll() {
				this.logoutDialog = false
				this.$store.dispatch('AUTH_LOGOUT', true)
			},
		}
	}
</script>